module.exports = __webpack_public_path__ + "img/topImg.95fe08bb.png";